module.exports = __webpack_public_path__ + "img/icon-black.4f2e9b72.svg";